import { getSwapApi, updateSwapApi, addSwapApi, deleteSwapApi } from "../components/constant/Api";
import { myApi } from "./api";

export const userApi = myApi.injectEndpoints({
    endpoints: (builder) => ({

        getSwap: builder.query({
            query: () => {
                return {
                    url: getSwapApi,
                    method: "GET",
                };
            },
            transformResponse: (response, meta, arg) => {
                return response.status ? response : { data: [], total: 0 };
            },
            providesTags: (_) => ["user"],
        }),
        updateSwap: builder.mutation({
            query: (post) => ({
                url: updateSwapApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["user"],
        }),
        addSwap: builder.mutation({
            query: (post) => ({
                url: addSwapApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["user"],
        }),
        deleteSwap: builder.mutation({
            query: (post) => ({
                url: deleteSwapApi,
                method: "POST",
                body: post
            }),
            invalidatesTags: (_) => ["user"],
        }),
    }),
});

export const { useGetSwapQuery, useUpdateSwapMutation, useAddSwapMutation, useDeleteSwapMutation } = userApi;